import { gql } from '@apollo/client';

import { imageFragment } from './fragments';

export const myListQuery = gql`
  query myListItemsPage($sessionContext: SessionContext!, $limit: Int, $cursor: String) {
    myListItemsPage(sessionContext: $sessionContext, limit: $limit, cursor: $cursor) {
      cursor
      items {
        title
        id
        locked
        metadataImages {
          poster {
            ...ImageFragment
          }
        }
        badges {
          label
          detailedLabel
        }
        flags {
          detailedLabel
          label
          flag
        }
        parentalControl {
          displaySubTitle
          displayTitle
          locked
        }
      }
    }
  }
  ${imageFragment}
`;
